// Public newsletter unsubscribe landing — reads ?email= and calls the API.
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";

export default function NewsletterUnsubscribe() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [status, setStatus] = useState(email ? "busy" : "missing");

  useEffect(() => {
    if (!email) return;
    api.get(`/newsletter/unsubscribe?email=${encodeURIComponent(email)}`)
      .then(() => setStatus("ok"))
      .catch(() => setStatus("fail"));
  }, [email]);

  return (
    <div className="py-20" style={{ background: "var(--parchment-2)", minHeight: "60vh" }}>
      <div className="container-prieure max-w-md">
        <div className="bg-white border p-8 text-center" style={{ borderColor: "var(--border)" }}
             data-testid="newsletter-unsubscribe-page">
          <div className="font-caps text-[0.7rem]" style={{ color: "var(--gold)", letterSpacing: "0.22em" }}>
            ◇ NEWSLETTER ◇
          </div>
          <h1 className="font-display text-3xl mt-3 mb-4">{t.ui.newsletterUnsubscribeTitle}</h1>

          {status === "missing" && (
            <p style={{ color: "var(--cinnabar)" }}>{t.ui.newsletterNoEmail}</p>
          )}
          {status === "busy" && (
            <p style={{ color: "var(--muted)" }}>{t.ui.newsletterBusy}</p>
          )}
          {status === "ok" && (
            <>
              <p className="text-lg mb-3" style={{ color: "var(--moss)" }}>{t.ui.newsletterOk}</p>
              <p className="text-sm" style={{ color: "var(--ink-2)" }}>
                {t.ui.newsletterOkBody.split("{email}").map((part, i, arr) => (
                  <span key={i}>
                    {part}
                    {i < arr.length - 1 && <strong>{email}</strong>}
                  </span>
                ))}
              </p>
            </>
          )}
          {status === "fail" && (
            <p style={{ color: "var(--cinnabar)" }}>{t.ui.newsletterFail}</p>
          )}

          <Link to="/" className="btn btn-outline mt-6 inline-block">
            {t.ui.backToHome}
          </Link>
        </div>
      </div>
    </div>
  );
}
